import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

export default class {
  constructor() {
    this.type = 'slide';
  }

  challenge(className) {
    const splide = new Splide(className, {
      type: this.type,
      perPage: 1,
      arrows: false,
      grid: {
        rows: 2,
        cols: 6,
        gap: {
          row: '16px',
          col: '16px',
        },
      },
      breakpoints: {
        768: {
          grid: {
            rows: 2,
            cols: 2,
          },
          gap: {
            row: false,
            col: false,
          },
        },
      },
    });
    splide.on('overflow', (isOverflow) => {
      splide.options = {
        pagination: isOverflow,
        drag: isOverflow,
      };
    });
    splide.mount({
      Grid,
    });
  }

  voice(className) {
    const splide = new Splide(className, {
      type: this.type,
      perPage: 1,
      autoHeight: true,
      arrows: false,
      grid: {
        rows: 2,
        cols: 3,
        gap: {
          row: '16px',
          col: '40px',
        },
      },
      breakpoints: {
        768: {
          autoHeight: false,
          grid: {
            rows: 2,
            cols: 1,
          },
          gap: {
            row: false,
            col: false,
          },
        },
      },
    });
    splide.on('overflow', (isOverflow) => {
      splide.options = {
        pagination: isOverflow,
        drag: isOverflow,
      };
    });
    splide.mount({
      Grid,
    });
  }
}
